import { cloneDeep } from 'lodash';
import moment from 'moment';
import * as util from './apiUtils';

export const getAccountService = (app, docType) => {
  let service = docType ? app.service(`${docType}`) : app.service('account');
  return service;
};

export const getIntegrationService = (app) => {
  const service = app.service('integration');
  return service;
};

export const getCsvExportService = (app) => {
  const service = app.service('csv-export');
  return service;
};

export const getReportService = (app) => {
  const service = app.service('report-service');
  return service;
};

export const getJobService = (app) => {
  const service = app.service('job');
  return service;
};

export const getListDataService = (app) => {
  const service = app.service('list-data');
  return service;
};

export const getDropdownDataService = (app) => {
  const service = app.service('dropdown-data');
  return service;
};

export const getExportTransactionService = (app) => {
  const service = app.service('export-transaction');
  return service;
};

export const getCsvExportRecord = (app) => {
  const service = app.service('csv-export');
  return service;
};

export const getRecordService = (app) => {
  const service = app.service('record');
  return service;
};

export const getFieldService = (app) => {
  const service = app.service('field');
  return service;
};

export const getGenerateMatrixItemService = (app) => {
  const service = app.service('generate-matrix-items');
  return service;
};

export const getLoyaltyService = (app) => {
  const service = app.service('loyalty-service');
  return service;
};

export const getCustomerPaymentService = (app) => {
  const service = app.service('customer-payment-service');
  return service;
};

export const getPdfService = (app) => {
  const service = app.service('pdf');
  return service;
}

// TODO: remove me later when not used anymore (used by systemnotes only)
// export function findDocs(app, options) {
//   const { query, docType } = options;
//   const service = getAccountService(app, docType);
//   const findOpts = { query };
//   findOpts.profile = app.get('user_info');
//   query.limit = 1000000;
//   return service.find({
//     query
//   });
// }

export async function streamSaveDoc(app, options, url) {
  const service = getAccountService(app, url || options.doc.doc_type);
  const { doc, timeout } = options;

  if (timeout) service.timeout = timeout;

  const data = doc;
  return service.create(data, {}, false, {
    headers: {
      'content-type': 'application/custom-stream',
    },
    timeout: timeout || 1000000,
  });
}

export async function saveDoc(app, options, url) {
  const service = getAccountService(app, url || options.doc.doc_type);
  const { source = {}, doc, is_renew, timeout, params } = options;
  let { id, _id } = source;

  if (timeout) service.timeout = timeout;

  // system fields
  doc.system_defined = util.toBoolean(source.system_defined);
  if (!doc.system_defined) {
    delete doc.system_defined;
  }

  //TODO: Temporary fix for modal on record.
  if (_id && !id) {
    id = _id;
  }

  //TODO: Temporary fix for copy Price book
  if (is_renew) {
    id = null;
  }

  doc.context = 'admin'

  if (id) {
    doc._id = id;
    return service.patch(id, doc, params);
  }

  return service.create(doc, params);
}

export function deleteDoc(app, options) {
  const { id, docType } = options;
  const service = getAccountService(app, docType);

  return service.remove(id);
}

export function getDoc(app, data, params = {}) {
  const { id, docType } = data;
  const service = getAccountService(app, docType);

  return service
    .get(id, params)
    .then((result) => {
      const docTypes = ['entity', 'sale_transaction'];

      if (result.custom_fields) {
        result.custom_fields._errors = null;
      }

      if (docTypes.indexOf(result.doc_type) > -1) {
        return result;
      }

      const convertedDoc = util.convertDocIds(result);
      return convertedDoc;
    })
    .catch((err) => {
      console.error(err);
      return null;
    });
}

export function getDocs(app, data) {
  const { methodType, filters = {}, list_type, doc_type } = data;
  const newFilters = parseFilters(filters, list_type);

  const service = getAccountService(app, doc_type || list_type);
  return service.find({ methodType, query: { ...newFilters } }).then((res) => {
    res.data = res.data.map((data) => {
      data._id = data.id;
      return data;
    });
    return res;
  });
}

export function parseFilters(filters, list_type) {
  const newFilters = cloneDeep(filters);
  const { requested_page = 1, rows_per_page = 10 } = newFilters;

  newFilters.skip = (requested_page - 1) * rows_per_page;
  newFilters.limit = rows_per_page;
  newFilters.list_type = list_type;

  const sortKeys = Object.keys(newFilters.sorted_columns || {});

  if (sortKeys) {
    newFilters.sort = sortKeys.map((sortKey) => {
      const { direction } = newFilters.sorted_columns[sortKey];
      return [sortKey, direction];
    });
  }

  delete newFilters.requested_page;
  delete newFilters.rows_per_page;
  delete newFilters.sorted_columns;

  return newFilters;
}

export function queryDocs(app, docType, params, methodType) {
  const docTypeService = getAccountService(app, docType);
  return docTypeService.find({ methodType, query: params });
}

export function handleError(error) {
  console.error('handleError error', error);
  if (error.name === 'BadRequest') {
    throw error;
  } else {
    console.error(error);
    throw error;
  }
}

export function getListData(app, data) {
  // TODO:
  // const service = getListDataService(window.app_socket);
  // let res = service.find({ query: { ...data } });
  // if(res && res.docs) {
  //   res.docs = res.docs.map(obj => {
  //     if(!obj.id) {
  //       obj.id = obj._id;
  //     }
  //     return obj;
  //   });
  // }
  return { docs: [], total: 0 };
}

export function getLoyaltyData(app, data) {
  // const service = getLoyaltyService(app);
  return [];
}

export function getCustomerPaymentData(app, data) {
  // const service = getCustomerPaymentService(app);
  return [];
}

export function exportTransaction(app, data) {
  const service = getExportTransactionService(app);
  return service.create(data);
}

export function getDropdownData(app, options, dropdownOptions) {
  // const service = getDropdownDataService(app);
  // return service.find(options).then(res => {
  //   if (res.docs) {
  //     return res.docs || []
  //   } else {
  //     return res
  //   }
  // });

  return [];
}

export function getDropdownList(app, options) {
  const query = options.query;
  const dropdownType = query.dropdown_type;
  const dropdownTypes = {
    customer: 'entity',
    contact: 'entity',
    employee: 'entity',
    supplier: 'entity',
  };
  const service = getAccountService(
    app,
    dropdownTypes[dropdownType] || dropdownType,
  );
  const params = {
    ...query,
    ...(query.searchParams || {}),
  };

  delete params.searchParams;
  delete params.dropdown_type;
  delete params.preload;
  delete params.filter;
  return service.find({ methodType: 'post', query: params });
}

export function addDocList(app, options) {
  const now = moment.utc();
  const service = getAccountService(app, options.docType);
  const { doc_arr, user = {} } = options;

  const docList = doc_arr.map((doc) => {
    // system fields
    // doc.tenant = util.toStringText(query.tenant_id);
    doc.last_updated = now.format();
    doc.last_updated_by = util.toObjectId(user.id);
    if (!doc.system_defined) {
      delete doc.system_defined;
    }

    // Create
    doc.created_datetime = now.format();
    doc.created_by = util.toObjectId(user.id);
    return doc;
  });
  // const docList = [];

  // INSERT
  return service.create(docList);
}

export function generatePdf(app, params) {
  const pdf = app.service('pdf');

  return pdf
    .create(params)
    .then((res) => {
      if (!res) throw new Error('UNABLE TO GENERATE THE PDF');
      return res;
    })
    .catch((err) => {
      throw err;
    });
}

export function previewPdf(app, data) {
  const service = app.service('pdf/preview');
  const response = service.create(data);
  return response;
}

export function email(app, opts) {
  const service = app.service('mail');
  const response = service.create(opts);
  return response;
};

export function sms(app, opts, params) {
  const service = app.service('entity/sms');
  const response = service.create(opts, params);
  return response;
};


export function search(app, params) {
  const service = getAccountService(app, 'search');
  const response = service.create(params);
  return response;
}
